import { type FC, type SVGProps } from 'react';

const Shutdown: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg width={23} height={25} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M11.545 13.78a1.139 1.139 0 0 0 1.15-1.14V1.15a1.15 1.15 0 0 0-.34-.81 1.14 1.14 0 0 0-1.25-.253c-.14.058-.265.144-.37.253a1.11 1.11 0 0 0-.34.81v11.49a1.14 1.14 0 0 0 1.15 1.14Z'
      fill='#B3B3B3'
    />
    <path
      d='M16.815 2.42a1.17 1.17 0 0 0-.88-.07 1.14 1.14 0 0 0-.67.57 1.17 1.17 0 0 0-.08.88c.097.288.3.529.57.67a9.19 9.19 0 1 1-9.89 15.39 9.19 9.19 0 0 1 1.46-15.39 1.08 1.08 0 0 0 .35-.28 1.26 1.26 0 0 0 .22-.39 1.16 1.16 0 0 0 0-.45 1.25 1.25 0 0 0-.12-.43 1.08 1.08 0 0 0-.28-.35 1.2 1.2 0 0 0-.4-.22 1.09 1.09 0 0 0-.44-.05 1.16 1.16 0 0 0-.44.12 11.49 11.49 0 1 0 10.55 0h.05Z'
      fill='#CDCCCC'
    />
  </svg>
);

export default Shutdown;
